import type { AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode } from "react";

interface StyleProps {
  variant?: "default" | "primary" | "quiet";
  tone?: "default" | "danger";
  size?: "md" | "small";
  block?: boolean;
}

const classes = ({ variant = "default", tone = "default", size = "md", block }: StyleProps, extra?: string) =>
  ["ds-button", variant !== "default" && `ds-button--${variant}`, tone === "danger" && "ds-button--danger", size === "small" && "ds-button--small", block && "ds-button--block", extra].filter(Boolean).join(" ");

export function Button({ variant, tone, size, block, className, type = "button", ...rest }: StyleProps & ButtonHTMLAttributes<HTMLButtonElement>) {
  return <button type={type} className={classes({ variant, tone, size, block }, className)} {...rest} />;
}

/** Mesmo visual de botão para links (WhatsApp, por exemplo). */
export function LinkButton({ variant, tone, size, block, className, ...rest }: StyleProps & AnchorHTMLAttributes<HTMLAnchorElement>) {
  return <a className={classes({ variant, tone, size, block }, className)} {...rest} />;
}

export function IconButton({ label, children, ...rest }: { label: string; children: ReactNode } & ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button type="button" className="ds-icon-button" aria-label={label} title={label} {...rest}>
      {children}
    </button>
  );
}
